module.exports = __webpack_public_path__ + "static/media/berkshire_winter.6ea9fa47.jpg";